import { postAsync } from '@/helpers/main';
import { useStore } from '@/store/main';
import { useSttStore } from '@/store/stt';
import { useReplyLanguageStore } from '@/store/replyLanguage';

export async function saveUserProfile() {
	const store = useStore();
	const sttStore = useSttStore();
	const replyStore = useReplyLanguageStore();
	const { id, email, status, userName, nickName, mobile, birthday, gender } = store.user;
	const payload = {
		id,
		email,
		status,
		userName,
		nickName,
		mobile,
		birthday,
		gender,
		relyLanguage: replyStore.getReplyLanguage,
		speechLanguage: sttStore.getSttSpeechLanguage,
	};
	try {
		await postAsync(`/appUserLogin/saveUserProfile`, payload);
	} catch (error) {
		console.error(error);
	}
}
